<template>
    <div class="app-container">
      <!-- 导航栏 -->
      <a-layout-header class="nav-header">
        <div class="container head-box">
          <div class="logo-site head-left">
            <a href="/sgkPage">
                <img src="../../../public/logosgk.png" alt="挖数据提供安全、稳定的数据服务" class="logo-img">
            </a>
            
          </div>
          <div class="home-phone h5-none">
            <div>
              <p class="font-weight-bold">本站查询数据</p>
              <p class="text-red font-weight-bold">不可公开传播</p>
            </div>
          </div>
          <div class="nav-list">
            <a-button type="primary" href="https://qq.qqpqm.top/sgk/help.html" target="_blank">
              常见问题
            </a-button>
          </div>
        </div>
      </a-layout-header>

      <div class="top-notice h5-none">
        <a-alert type="info" banner>
            <div>
                <div class="notice-content">
              <span class="icon-cast">当前位置></span>
              <span class="icon-cast">其他查询></span>
              <span class="icon-cast"><a>车辆行驶轨迹查询</a></span>
                </div>
            </div>
            
        </a-alert>
      </div>

      <!-- 主要内容 -->
      <div class="main-content">
        <div class="mt_5">
          <!--头部-->
          <div class="head_index contain_box shadows" style="display: flex;">
            <span class="head_left float-left float_none">
              <img class="floatLeft" style="width: 150px;" src="../../../public/image/logo18.png">
              <div class="floatLeft h5_right">
                <h1 class="font_weight" style="font-size:1.3rem">车辆行驶轨迹查询</h1>
              </div>
            </span>
            <span class="head_right float-left float_none" style="width: 100%;">
              <div class="list-group mt_15">
                <div class="amount1">
                  <div style="padding-bottom: 10px; width: 100%; display: flex">
                    <input type="text"  style="color: #666; flex: 1" class="keys" v-model="identity" name="identity" placeholder="输入需查询的车牌号码"  maxlength="18">
                    <input type="email" style="color: #666; flex: 1; margin-left: 10px" class="keys" v-model="email" name="email" placeholder="接收查询结果的邮箱"  maxlength="30">
                  </div>
                  <div style="padding-bottom: 10px; width: 97%">
                    <input type="text" style="color: #666" class="keys" v-model="notes" name="notes" placeholder="请填写备注,非必填" maxlength="30">
                  </div>
                </div>
              </div>
              <input type="hidden" name="condition" value="1">
              <p class="text-gray mt_30">
                <span class="font_14" >
                  <b class="text-danger font_18 ng-scope" style="font-size: 18px;">价格：$ 30.00</b>
                </span>
              </p>
              <button type="submit" id="submit"  @click="handleSubmit"  class="btn add_btns btn-primary mt_15 float-left" style="cursor: pointer;">立即查询</button>
              <p style="
                  text-align: right;
                  margin-right: 10px;
                  right: 0;
                  margin-top: 35px;
                ">
                累积 <b style="color: #ff3333 !important">23465</b> 人完成查询
              </p>
            </span>
          </div>
        
        <!--介绍-->
        <div class="head_index contain_box shadows" style="line-height: 25px">
          <p b="" style="color: red; font-size: 20px">
            请各位不要再问价格有没有优惠，都是一口价，由于内部政策等问题实际查询成本还可能波动上涨。
          </p>
          <p>车轨的如模板所示。需要注意的是，有延迟大概1-2周的时间。比如3月15日查，可能最新的只到3月7日。
          </p>
          <p>
            只出5页，这5页内容跑了什么路，取决于他平时开车的频率，比如每天都开车的话，5页内容可能仅仅是他几天的记录。如果频率不高，5页的内容可能覆盖了几个月的活动轨迹。车辆轨
          </p>
          <p>
            迹只记录在道路的行驶情况，车辆停靠地点无法直接通过车辆轨迹得出，需要你结合车主的行为逻辑，自己推断。
          </p>
          
          <p>
            另外，如果是全国跑的话，有卡口版本，只记录跨省的卡口，一般不出这个版本，如果有需要这个版本的话另提。如果在记录里看到卡口名，不用问我。卡口名是专业词汇，通常是道路交通部门的人使用。
          </p>
          <p>社工库-</p>
        </div>
        <!--内容-->
        <div class="content_text contain_box shadow">
          <div class="title">
            <ul>
              <li>查询案例</li>
            </ul>
          </div>
          <div class="list">
            <!--Api文档-->
            <div class="Api_word">
              <div class="right_content float-left">
                <p>
                  <img src="../../../public/image/18-1.jpeg" style="max-width: 100%"><span style="font-weight: bold"><br></span>
                </p>
                <p>
                  <img src="../../../public/image/18-2.jpeg" style="max-width: 100%">
                </p>
                <p>
                  <img src="../../../public/image/18-3.jpeg" style="max-width: 100%"><span style="font-weight: bold"><br></span>
                </p>
                <p>
                  <img src="../../../public/image/18-2.jpeg" style="max-width: 100%">
                </p>
               
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>

         <div class="content_text contain_box shadow" style="margin-top: 3px">
          <div class="title">
            <ul>
              <li>下单记录</li>
            </ul>
          </div>
          <div id="scrolling-list">
            <ul>
            <li><span class="email">邮箱：1763175***@qq.com</span><span class="datetime">时间：2025-08-04 13:48:32</span><span class="usdt">金额：$39.9.00</span></li><li><span class="email">邮箱：2370059***@qq.com</span><span class="datetime">时间：2025-08-05 10:45:32</span><span class="usdt">金额：$99.85.00</span></li><li><span class="email">邮箱：zxc23231***@gmail.com</span><span class="datetime">时间：2025-08-04 19:44:32</span><span class="usdt">金额：$69.9.00</span></li><li><span class="email">邮箱：cjn***@gmail.com</span><span class="datetime">时间：2025-08-04 23:24:32</span><span class="usdt">金额：$69.9.00</span></li><li><span class="email">邮箱：2370059***@qq.com</span><span class="datetime">时间：2025-08-05 01:58:32</span><span class="usdt">金额：$49.9.00</span></li><li><span class="email">邮箱：cjn***@gmail.com</span><span class="datetime">时间：2025-08-04 23:03:32</span><span class="usdt">金额：$129.9.00</span></li><li><span class="email">邮箱：cyx1024***@gmail.com</span><span class="datetime">时间：2025-08-04 16:39:32</span><span class="usdt">金额：$69.9.00</span></li><li><span class="email">邮箱：508340***@qq.com</span><span class="datetime">时间：2025-08-05 04:23:32</span><span class="usdt">金额：$129.9.00</span></li><li><span class="email">邮箱：4608***@qq.com</span><span class="datetime">时间：2025-08-04 21:39:32</span><span class="usdt">金额：$99.85.00</span></li><li><span class="email">邮箱：zxc23231***@gmail.com</span><span class="datetime">时间：2025-08-05 08:17:32</span><span class="usdt">金额：$99.85.00</span></li><li><span class="email">邮箱：zxc23231***@gmail.com</span><span class="datetime">时间：2025-08-05 07:34:02</span><span class="usdt">金额：$39.9.00</span></li><li><span class="email">邮箱：alexwilliams789@qq.com</span><span class="datetime">时间：2025-08-05 03:43:32</span><span class="usdt">金额：$59.9.00</span></li><li><span class="email">邮箱：4608***@qq.com</span><span class="datetime">时间：2025-08-05 04:25:02</span><span class="usdt">金额：$39.9.00</span></li><li><span class="email">邮箱：4608***@qq.com</span><span class="datetime">时间：2025-08-05 07:38:32</span><span class="usdt">金额：$49.9.00</span></li></ul>
        </div>
        </div>
      </div>
      </div>
    
      <!-- 页脚 -->
      <a-layout-footer class="footer">
        <div class="container">
          <div class="copyright">
            <a  href="/sgkPage" style="color:#fff">社工库</a>@版权所有: © 2018-2025
          </div>
        </div>
      </a-layout-footer>
  
      <!-- 返回顶部按钮 -->
      <a-back-top />
    </div>
  </template>
  
  <script>
import { resolveReferralContext } from '../../util/deeplink';
import { serializePaymentPayload } from '../../util/paymentFlow';
  import { ref, computed,onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { message } from 'ant-design-vue';
  import { useRouter } from 'vue-router';
  import { addOrder } from '../../util/api'; 
  
  export default {
    name: 'wokerDetail',
    setup() {
      const route = useRoute();
      const referral_code = ref('');
        const gameGroupId = ref('');
        const router = useRouter();
        const activeTab = ref('all');
        const searchKey = ref('');

        const identity = ref('');
        const email = ref('');
        const notes = ref('');
      
      // 公告数据
      const notices = ref([
        '查询数据需要挖掘并不能实时获取到数据,一般会在30分钟内将数据发到你的邮箱！',
      ]);
      
      // 服务数据
      const services = ref([
        {
          id: 1,
          title: '查询个人开房记录',
          description: '社工库-查询开房记录需要提供身份证号,只能查询最近3年内的酒店入住记录,一般30分钟出结果。',
          price: '20.00',
          image: '../../public/酒店.png',
          url: 'https://qq.qqpqm.top/sgk/1.html'
        },
        {
          id: 2,
          title: '移动联通电信机主实名信息查询',
          description: '社工库-目前只支持中国大陆手机号必须移动联通电信三网的手机号,不支持广电手机号,因为数据库后还没的打通,需要一些时间才可以查询。',
          price: '8.00',
          image: '../../public/酒店.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 3,
          title: '移动联通电信机主实名信息查询',
          description: '社工库-目前只支持中国大陆手机号必须移动联通电信三网的手机号,不支持广电手机号,因为数据库后还没的打通,需要一些时间才可以查询。',
          price: '8.00',
          image: '../../public/酒店.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 4,
          title: '移动联通电信机主实名信息查询',
          description: '社工库-目前只支持中国大陆手机号必须移动联通电信三网的手机号,不支持广电手机号,因为数据库后还没的打通,需要一些时间才可以查询。',
          price: '8.00',
          image: '../../public/酒店.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        // 添加更多服务...
      ]);

      onMounted(() => {
          const referralCtx = resolveReferralContext(route);
          referral_code.value = referralCtx.referralCode;
          gameGroupId.value = referralCtx.gameGroupId
      }); 
      
      // 过滤服务
      const filteredServices = computed(() =>
        services.value.filter(service => 
            service.title.includes(searchKey.value) || 
            service.description.includes(searchKey.value)
        )
        );

        const handleSubmit = async() => {
            if ( email.value == "" ||  identity.value == "" || notes.value == "") {
                message.warning('请输入信息');
                return
            }
            
            let str = getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
            let data = {
                price:30,
                inputNumber:1,
                inputGT:email.value,
                orderNo: str,
                title:"车辆行驶轨迹查询",
                referral_code:referral_code.value
            }
            console.log(identity)
            console.log(notes)

            await addOrder(data)
            
            router.push({ name: 'Payment', params: { data: serializePaymentPayload(data, gameGroupId.value) } });
        };

      // 切换标签
      const handleTabChange = (key) => {
        console.log('Tab changed:', key);
        // 这里可以添加根据标签过滤服务的逻辑
      };

      const getCurrentDateTime =() =>  {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }
      
      // 搜索
      const handleSearch = (value) => {
        console.log('Search:', value);
      };
      
      // 跳转到服务详情
      const goToService = (url) => {
        window.open(url, '_blank');
      };
      
      return {
        handleSubmit,
        activeTab,
        identity,
        email,
        notes,
        searchKey,
        notices,
        services,
        filteredServices,
        handleTabChange,
        handleSearch,
        goToService
      };
    }
  };
  </script>
  
  <style scoped>
  .app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .nav-header {
    background: #fff;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }
  
  .head-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 64px;
  }
  
  .logo-site img {
    width: 168px !important;
    margin-left: 6rem;
  }
  
  .home-phone {
    display: flex;
    width: 100%;
    justify-content:left
  }
  
  .text-red {
    color: #ff4d4f !important;
  }
  
  .top-notice {
    margin-bottom: 16px;
    margin: 20px auto 20px auto;
    width: 1200px;
    display: block;
    position: relative;
    color: red
  }
  
  .notice-content {
    display: flex;
    align-items: center;
  }
  .notice-slide {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 16px;
  background-color: #fffbe6;
}
  
  .main-content {
    background: #FFF;
    width: 1200px;
    margin: 0 auto;
    flex: 1;
    padding: 20px 30px;
  }
  
  .api-order {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .service-card {
    width: 29%;
    margin-right: 1%;
    text-align: left;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    margin: 0 1% 10px 0;
    float: left;
    padding: 20px 10px;
    position: relative;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
  }
  
  .service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .service-image {
    height: 160px;
    object-fit: contain;
  }
  
  .service-desc {
    font-size: 12px;
    margin-bottom: 8px;
    color: #000;
    height: 48px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .head_left{
    min-width: 20%;
    text-align: center;
    margin-right: 2%;
  }

  .keys{
    outline-style: none;
    outline-width: 0px;
    border: 1px solid #dfdfdf;
    /* border-style: none; */
    text-shadow: none;
    -webkit-appearance: none;
    -webkit-user-select: text;
    outline-color: transparent;
    border-radius: 6px;
    box-shadow: 0px 0px 29px 0px rgb(7 15 72 / 10%);
    width: 100%;
    height: 100%;
    padding-left: 3%;
    height: 50px;
  }
  
  .price {
    color: #ff6633 !important;
    font-weight: bold;
  }
  
  .footer {
    text-align: center;
    padding: 16px 0;
    color: #fff;
    background: #1e2123;
    font-size: 14px;
    font-family: '微软雅黑';
  }
  .copyright{
    color: #fff;
  }
  .font-weight-bold{
    margin-block-start:0px;
    margin-block-end:0px;
    color: #000;
    font-weight: 500;
  }

              
  .service-price{
    margin-block-start:0px;
    margin-block-end:0px;
    margin-top: auto;
  }

  /* Added styles for the new content */
  .mt_5 {
    margin-top: 5px;
  }
  .head_index {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
  }
  .contain_box {
    border: 1px solid #e6e6e6;
    border-radius: 4px;
  }
  .shadows {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }
  .float-left {
    float: left;
  }
  .float_none {
    float: none;
  }
  .h5_right {
    margin-left: 15px;
  }
  .font_weight {
    font-weight: bold;
    line-height: 2;


  }
  .list-group {
    margin-bottom: 15px;
  }
  .mt_15 {
    margin-top: 15px;
  }
  .text-gray {
    color: #666;
  }
  .text-danger {
    color: #ff4d4f;
  }
  .btn-primary {
    background-color: #1890ff;
    border-color: #1890ff;
    color: #fff;
  }
  .btn{
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid #e6e6e6;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 5px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .content_text {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
  }
  .title ul {
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #e6e6e6;
  }
  .title li {
    display: inline-block;
    padding: 10px 20px;
    border-bottom: 2px solid #1890ff;
    margin-bottom: -1px;
  }
  #scrolling-list {
    height: 300px;
    overflow-y: auto;
  }
  #scrolling-list ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  #scrolling-list li {
    padding: 10px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    justify-content: space-between;
  }
  
  @media (max-width: 768px) {
    :deep(.ant-col-md-8) {
        display: block;
        flex: 32%;
        max-width: 33.33333333333333%;
    }
    .h5-none {
      display: none;
    }
    
    .head-box {
      padding: 0 12px;
    }
    
    .service-list {
      margin: 0 -8px;
    }
    
    .service-image {
      height: 120px;
    }
  }
  </style>